module.exports = __webpack_public_path__ + "img/licence1-2.9cf594fd.jpg";